import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';

const ScrollLockContext = createContext();

const SCROLL_LOCK_KEY = 'trivana_scroll_locked';

export const useScrollLock = () => useContext(ScrollLockContext);

// Helper to check if scroll is locked (can be called outside React)
export const isScrollLocked = () => {
  try {
    return sessionStorage.getItem(SCROLL_LOCK_KEY) === 'true';
  } catch (e) {
    return false;
  }
};

export const ScrollLockProvider = ({ children }) => {
  // Initialize from sessionStorage
  const [isLocked, setIsLocked] = useState(() => {
    try {
      return sessionStorage.getItem(SCROLL_LOCK_KEY) === 'true';
    } catch (e) {
      return false;
    }
  });

  const lockScroll = useCallback(() => {
    try {
      sessionStorage.setItem(SCROLL_LOCK_KEY, 'true');
    } catch (e) {}
    setIsLocked(true);
  }, []);

  const unlockScroll = useCallback(() => {
    try {
      sessionStorage.removeItem(SCROLL_LOCK_KEY);
    } catch (e) {}
    setIsLocked(false);
  }, []);

  // Sync with sessionStorage changes
  useEffect(() => {
    const checkLock = () => {
      try {
        const locked = sessionStorage.getItem(SCROLL_LOCK_KEY) === 'true';
        if (locked !== isLocked) {
          setIsLocked(locked);
        }
      } catch (e) {}
    };
    
    const interval = setInterval(checkLock, 100);
    return () => clearInterval(interval);
  }, [isLocked]);

  return (
    <ScrollLockContext.Provider value={{ isLocked, lockScroll, unlockScroll }}>
      {children}
    </ScrollLockContext.Provider>
  );
};
